import { render } from "./LeftTransactionRecently.vue?vue&type=template&id=17644ba4"
import script from "./LeftTransactionRecently.vue?vue&type=script&lang=js"
export * from "./LeftTransactionRecently.vue?vue&type=script&lang=js"
script.render = render

export default script